// greenLedgerPersist.js — F13-E4-T04: o edit-vs-green ledger SOBREVIVE ao
// reload/próximo run. O PR12 criou a semente (initSpineState aceita seq/files)
// mas NINGUÉM persistia o snapshot no fim do run — o ledger renascia zerado e
// um edit pré-reload podia se passar por verde fresco. Persistência per-session
// em localStorage, best-effort (sem window/erro ⇒ no-op honesto).
// I/O adapter (localStorage) — vive FORA de loop/ de propósito: o arch test
// framework-free varre loop/ inteiro e window.* é vetado lá.

import { snapshotLedger } from './oracle/greenLedger.js';

const KEY = (sessionId) => `apolo:greenLedger:${sessionId}`;

/** Semente pro initSpineState do próximo run ({} quando não há snapshot). */
export function loadLedgerSeed(sessionId) {
  if (!sessionId || typeof window === 'undefined' || !window.localStorage) return {};
  try {
    const raw = window.localStorage.getItem(KEY(sessionId));
    if (!raw) return {};
    const snap = JSON.parse(raw);
    if (!snap || typeof snap.seq !== 'number') return {};
    return { greenLedgerSeq: snap.seq, greenLedgerFiles: snap.files || {} };
  } catch { return {}; }
}

/** Persiste o snapshot do ledger do spine ao fim do run (best-effort). */
export function persistLedger(sessionId, spine) {
  if (!sessionId || !spine?.greenLedger || typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.setItem(KEY(sessionId), JSON.stringify(snapshotLedger(spine.greenLedger)));
  } catch { /* quota/priv mode — no-op */ }
}
